import { ENC_KEY_AES256GCM } from "@/config/Constants";
import forge from "node-forge";


export const AESGCM_DECRYPT = function (data) {
  const bytes = forge.util.hexToBytes(data);
  const iv = bytes.slice(0, 12);
  const tag = bytes.slice(12, 28);
  const ciphertext = bytes.slice(28);
  const binKey = forge.util.hexToBytes(ENC_KEY_AES256GCM);
  const decipher = forge.cipher.createDecipher("AES-GCM", binKey);
  decipher.start({ iv, tag });
  decipher.update(forge.util.createBuffer(ciphertext));
  decipher.finish();
  return binToUtf8(decipher.output.data);
};

export const AESGCM_ENCRYPT = function (data) {
  const iv = forge.random.getBytesSync(12);
  const cipher = forge.cipher.createCipher("AES-GCM", forge.util.hexToBytes(ENC_KEY_AES256GCM));
  cipher.start({ iv, tagLength: 16 });
  cipher.update(forge.util.createBuffer(utf8ToBin(data)));
  cipher.finish();
  return forge.util.bytesToHex(iv + cipher.mode.tag.data + cipher.output.data);
};

function utf8ToBin(data) {
  if (typeof Buffer !== "undefined") {
    // node
    return Buffer.from(data, "utf8").toString("binary");
  } else if (typeof TextEncoder !== "undefined") {
    // modern browsers
    const encoder = new TextEncoder();
    const buf = encoder.encode(data);
    let bin = "";
    buf.forEach(function (i) {
      bin += String.fromCharCode(i);
    });
    return bin;
  } else {
    // slower but vanilla js
    const escstr = encodeURIComponent(data);
    const bin = escstr.replace(/%([0-9A-F]{2})/gi, function ($0, hex) {
      return String.fromCharCode(parseInt(hex, 16));
    });
    return bin;
  }
}
function binToUtf8(data) {
  if (typeof Buffer !== "undefined") {
    // node
    return Buffer.from(data, "binary").toString("utf8");
  } else if (typeof TextDecoder !== "undefined" && typeof Uint8Array !== "undefined") {
    // modern browsers
    const decoder = new TextDecoder("utf-8");
    const arr = [];
    data.split("").forEach(function (c) {
      arr.push(c.charCodeAt(0));
    });
    return decoder.decode(Uint8Array.from(arr));
  } else {
    // slower but vanilla js
    const escstr = data.replace(/./g, function (char) {
      let code = char.charCodeAt(0).toString(16).toUpperCase();
      if (code.length < 2) {
        code = "0" + code;
      }
      return "%" + code;
    });
    return decodeURIComponent(escstr);
  }
}
